import { useState, useEffect } from 'react'
import AgentWidget from './components/AgentWidget'
import FuturisticLoader from './components/loading/FuturisticLoader'
import './App.css'

export default function App() {
  const [loading, setLoading] = useState(true)
  const [showBackground, setShowBackground] = useState(false)

  useEffect(() => {
    // Timer para el cargador principal
    const timer = setTimeout(() => {
      setLoading(false)
    }, 4000)

    // Delay para montar el fondo pesado (Spline) y evitar lag inicial
    const bgTimer = setTimeout(() => {
      setShowBackground(true)
    }, 4000)

    return () => {
      clearTimeout(timer)
      clearTimeout(bgTimer)
    }
  }, [])

  return (
    <>
      <FuturisticLoader loading={loading} />
      {showBackground && <AgentWidget />}
    </>
  )
}

